// extracted by mini-css-extract-plugin
export default {"container":"UserInfo_container__nZGeG","form":"UserInfo_form__Ut7h5"};